<template>
    <div class="map-container" >
        <img :src="imgUrl" alt="" @click.stop="openView">
        <div class="marker" :style="'top:'+y+'%;left:'+x+'%;'">
            <!-- <img class="my-icon" src="../../../static/images/marker.png" alt=""> -->
        </div>
        <div class="pic-bg" v-show="isScale">
            <div class="top">
                <div class="close" @click.stop="closeView">×</div>
            </div>
            <div class="pic-map-container" >
                <div id="picView" class="pic-view" :style="'width:'+boxWidth+'%;height:'+boxHeight+'px;transform: translate3d('+viewX+'px, '+viewY+'px, 0px) scale('+viewScale+');'">
                    <img :src="imgUrl" alt="">
                    <!-- <img src="../../../static/images/banner_2.jpg" alt=""> -->
                    <div class="marker" :style="'top:'+y+'%;left:'+x+'%;'">
                        <!-- <img src="../../../static/images/marker.png" alt=""> -->
                    </div>
                </div>
                
            </div>
        </div>
        
    </div>
</template>

<script>
export default {
    data(){
        return{
            imgUrl:"",
            x:0,
            y:0,
            isScale:false,//是否缩放
            //maxWidth:document.getElementsByClassName("map-container")[0].style.width,
            maxHeight:400,
            clickCount:0,
            boxWidth:100,
            boxHeight:210,
            viewX:0,
            viewY:0,
            viewScale:1,
        }
    },
    props:{
        datas:{
            type:Object,
            default:()=>{}
        }
    },
    computed:{
        maxWidth(){
            return document.getElementsByClassName(".map-container")[0].style.width;
        }
    },
    methods:{
        test(){
            this.boxWidth = 200;
            this.boxHeight = 420;
        },
        openView(){
            this.isScale=true;
            this.$emit("myEvent",false);
        },
        closeView(){
            this.isScale = false;
            this.viewX=0;
            this.viewY=0;
            this.viewScale=1;
            this.$emit("myEvent",true)
        }
        // changeScale(){
        //     if(this.clickCount >0){
        //         this.isScale = !this.isScale;
        //         this.$emit("myEvent",this.isScale)
        //     }else{
        //         this.clickCount = 1
        //     }
        //     setTimeout(()=>{
        //         this.clickCount = 0
        //     },300);
        // }
    },
    created(){
        
    },
    mounted(){
        let dom = document.getElementById("picView");
        var startY = null; // 滑块开始滑动的水平位置
        var moveEndY = null; // 滑块结束滑动的水平位置
        var startX = null; // 滑块开始滑动的水平位置
        var moveEndX = null; // 滑块结束滑动的水平位置
        var containerHeight = null; // 选项容器的初始高度
        var startScaleX = null; // 
        var startScaleY = null; // 

        // 答题卡滑块事件
        dom.addEventListener("touchstart", (e)=>{
            // 取消默认动作
            e.cancelable && !e.defaultPrevented && e.preventDefault();
            let fingers = e.touches.length;
            // 原生的写法 ： startY = e.touches[0].pageY;
            if(fingers == 1){
                startY = e.touches[0].pageY;
                startX = e.touches[0].pageX;
            }else if(fingers == 2){
                startScaleX = Math.abs(e.touches[0].pageX - e.touches[1].pageX);
                startScaleY = Math.abs(e.touches[0].pageY - e.touches[1].pageY);
            }
        });
        dom.addEventListener("touchmove", (e)=> {
            // 取消默认动作
            e.cancelable && !e.defaultPrevented && e.preventDefault();
            // 原生的写法 ： moveEndY = e.touches[0].pageY;
            moveEndY = e.touches[0].pageY;
            moveEndX = e.touches[0].pageX;
            let fingers = e.touches.length;
            // 移动了的差值
            if(fingers == 1){
                var movedY = moveEndY - startY;
                var movedX = moveEndX - startX;
                startY += movedY;
                startX += movedX;
                Math.abs(this.viewX)
                let maxMove = (dom.offsetWidth*this.viewScale-document.body.clientWidth)/2;
                if(maxMove > Math.abs(this.viewX+movedX)){
                    this.viewX = this.viewX+movedX;
                }
                //this.viewX = this.viewX+movedX;
            }else if(fingers == 2){
                let endScaleX = Math.abs(e.touches[0].pageX - e.touches[1].pageX);
                let endScaleY = Math.abs(e.touches[0].pageY - e.touches[1].pageY);
                let picScaleX = endScaleX - startScaleX;
                let picScaleY = endScaleY - startScaleY;
                let picScale = null;
                // let picScale = Math.sqrt((picScaleX*picScaleX)+(picScaleY*picScaleY));
                // if(picScaleX<0 || picScaleY<0){
                //     picScale = this.viewScale - (picScale/1000);
                // }else{
                //     picScale = this.viewScale +(picScale/1000);
                // }
                picScale = this.viewScale + (picScaleY/1000);
                if(picScale >= 1 && picScale <3){
                    this.viewScale = picScale;
                    this.viewX = 0;
                    this.viewY = 0;
                }
                
            }
        });
        dom.addEventListener("touchend", (e)=> {
            // 动态改变文档底部占位符高度
            
        });
    },
    watch:{
        datas(value,oldValue){
            if(value != oldValue){
                this.imgUrl = value.url;
                this.x=parseFloat(value.x)*100;
                this.y= parseFloat(value.y)*100;
                let dom = document.getElementsByClassName(".marker")[0];
            }
        }
    }
}
</script>

<style>
    .map-container{
        width: 100%;
        height: 210px;
        position: relative;
        /*解决ios上滑动不流畅*/
        -webkit-overflow-scrolling: touch;
    }
    .map-container.scale{
        /* transform: scale(2); */
        width: 200%;
        height: 420px;
    }
    .map-container img{
        width:100%;
        height:100%;
    }
    .map-container .marker{
        width:16px;
        height: 16px;
        margin-left: -5px;
        margin-top: -5px;
        border-radius: 10px;
        position: absolute;
        background:url("../../../static/images/marker.svg") no-repeat 3px 4px;
        background-size: 10px;
        border: 1px solid #D81E06;
    }
    /***********/
    .map-container .pic-bg{
        position: fixed;
        top:0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #000;
        z-index: 999;
    }
    .map-container .pic-bg .pic-map-container{
        overflow: auto;
        width: 100%;
        height: 100vh;
        line-height: 100vh;

    }
    .map-container .pic-bg .pic-map-container::-webkit-scrollbar {
        display: none;
    }
    .map-container .pic-bg .pic-map-container .pic-view{
        display: inline-block;
        width: 100%;
        height: 210px;
        position: relative;
        vertical-align: middle;
        transform: translate3d(0px, 0px, 0px) scale(1);
    }
    .map-container .pic-bg .pic-map-container .pic-view img{
        vertical-align: top;
    }
    .map-container .pic-bg .pic-map-container .pic-view .marker{
        width:16px;
        height: 16px;
        margin-left: -5px;
        margin-top: -5px;
        border-radius: 10px;
        background: rgb(70,135,248);
        position: absolute;
        background:url("../../../static/images/marker.svg") no-repeat 3px 4px;
        background-size: 10px;
        border: 1px solid #D81E06;
    }
    .map-container .pic-bg .top{
        position: absolute;
        left: 0;
        top: 0;
        height: 44px;
        width: 100%;
    }
    .map-container .pic-bg .top .close{
        width: 44px;
        height: 44px;
        position: absolute;
        background: none;
        cursor: pointer;
        overflow: visible;
        -webkit-appearance: none;
        display: block;
        border: 0;
        padding: 0;
        margin: 0;
        float: right;
        opacity: .75;
        transition: opacity .2s;
        box-shadow: none;
        font-size: 36px;
        color: #fff;
        line-height: 44px;
        right: 0;
        z-index: 10;
    }
</style>





// WEBPACK FOOTER //
// src/components/common/searchCarMap.vue